import stocksApi from '@/apis/stocks'
import watchListApi from '@/apis/watchList'
import portfolioApi from '@/apis/portfolio'

const fillColors = ['#e93c44', '#01e70e', '#2774fb', '#cae200', '#dbab1f', '#180a89', '#029715', '#1cafe9', '#3d873c', '#848047']
const getStocksByAfId = async ({
  commit
}, { id, subs }) => {
  try {
    const {
      data: stocks
    } = await stocksApi.getStocksByAfId(id, subs)

    commit('STOCKS_UPDATE', { stocks: stocks.payload.stocks })
  } catch (error) {
    console.error('Failed to get stocks by id due to %s', error)
  }
}

const generateGraphData = (performanceSets) => {
  performanceSets = performanceSets.filter(performance => performance.timeseries !== null)
  if (performanceSets.length === 0) return
  const datasets = performanceSets.map((performance, index) => {
    const performanceTimeseries = performance.timeseries
    const refPrice = performanceTimeseries[0].close
    const fillColor = fillColors.splice(0, 1)

    return {
      label: performance.symbol,
      fill: false,
      backgroundColor: fillColor,
      borderColor: fillColor,
      borderWidth: 2,
      radius: 1,
      isActive: true,
      data: performanceTimeseries.map(entry => ((entry.close - refPrice) / refPrice * 100).toFixed(2))
    }
  })

  const timeseries = performanceSets[0].timeseries.map(entry => entry.date)
  return {
    labels: timeseries,
    datasets
  }
}

const getPerformance = async (stocks) => {
  try {
    const stocksArray = stocks.split(',').map(stock => {
      const formatStock = stock.split(':')
      return formatStock.length === 2 ? formatStock[1] : formatStock[0]
    }).join()
    const {
      data: portfolio
    } = await portfolioApi.getPerformance({
      stocks: stocksArray
    })
    return generateGraphData(portfolio.payload.data)
  } catch (error) {
    console.error('Failed to get all portfolio due to %s', error)
  }
}

const updateWatchList = async ({
  commit,
  state
}, stock) => {
  const isStockSelected = stock.selected
  commit('WATCH_LIST_UPDATE', {
    stock
  })
  if (stock.color) {
    fillColors.push(stock.color)
    stock.color = null
  }
  const watchListPayload = {
    customerid: window.$cookies.get('_uid'),
    _id: state.watchList.id,
    stocks: state.watchList.stockSymbols
  }

  try {
    watchListApi.addToWatchList(watchListPayload)
    if (isStockSelected) return null

    const graphData = await getPerformance(stock.alias)
    if (!graphData) {
      commit('STOCK_NO_GRAPH', [stock.alias])
    }
    return graphData
  } catch (error) {
    console.error('Failed to add to watch list %s', error)
  }
}

const getWatchList = async ({
  commit
}) => {
  try {
    let {
      data: watchList
    } = await watchListApi.getWatchList(window.$cookies.get('_uid'))

    watchList = watchList.payload.watchlist
    let graphData = null
    if (watchList.stocks && watchList.stocks.length > 0) {
      commit('WATCH_LIST_UPDATE', {
        watchList
      })
      graphData = await getPerformance(`${watchList.stocks.join(',')}`)
      if (!graphData) {
        commit('STOCK_NO_GRAPH', watchList.stocks)
      } else if (graphData.datasets.length < watchList.stocks.length) {
        const stocksHaveGraph = graphData.datasets.map(stock => stock.label)
        watchList.stocks = watchList.stocks.map(stock => stock.split(':')[1])
        commit('STOCK_NO_GRAPH', watchList.stocks.filter(value => stocksHaveGraph.indexOf(value) === -1))
      }
    }
    return graphData
  } catch (error) {
    console.error('Failed to retrieve watch list %s', error)
  }
}

const getStocksByPublicationId = async ({
  commit
}, id) => {
  try {
    const {
      data: stocks
    } = await stocksApi.getStocksByPublicationId(id)

    commit('STOCKS_UPDATE', { stocks: stocks.payload.stocks })
  } catch (error) {
    commit('STOCKS_UPDATE_FAILURE')
    console.error('Failed to retrieve stocks for publication %s', id)
  }
}

const getStocksByRecommendStatus = async ({
  commit
}, { id, stocks }) => {
  try {
    // eslint-disable-next-line
    const filteredStocks = stocks.filter(stock => stock.recommendation == id)

    commit('STOCKS_UPDATE', { stocks: filteredStocks })
  } catch (error) {
    commit('STOCKS_UPDATE_FAILURE')
    console.error('Failed to filtered stocks for publication %s', id)
  }
}

export default {
  getStocksByAfId,
  updateWatchList,
  getStocksByPublicationId,
  getStocksByRecommendStatus,
  getWatchList
}
